<template>
  <div class="row">
    <div class="col-12">
      <h4>{{ $t('app.modules.more_viewed.title') }}</h4>

      <div class="row">
        <div class="col-3" v-for="item in familiaProductos">
          <card-familia-producto
            :iconografia="item.iconografia"
            :title="item.productoPadre"
            :description="item.traducciones[0].descripcion"
            :idFamilia = "item.idFamiliaProducto"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getResponse} from "@/util/utilities";

export default {
name: "mostViewed",
  components: {
    CardFamiliaProducto: () => import("../catalogoProductos/cardFamiliaProducto")
  },
  data(){
    return {
      familiaProductos: []
    }
  },
  mounted() {
    this.loadFamilia();
  },
  methods: {
    async loadFamilia(){
      let payload = {
        OnlyPublish: true
      }

      let request = await this.$http.put(route("FamiliasProducto/getFamiliasProductoMasVistas"), payload);
      let response = getResponse(request, null);

      if(response != null){
        this.familiaProductos = response.familiasProductos;
      }
    }
  }
}
</script>

<style scoped>

</style>
